export const getISODate = (date) => {
  if (date === null) {
    return date;
  } else {
    const dt = new Date(date);
    // Extract raw date value to ignore timezone and then construct the isoString manually to use UTC and avoid timezone issues (All DB queries need UTC values!)
    const stringifiedDate = [
      String(dt.getFullYear()),
      String(101 + dt.getMonth()).substring(1),
      String(100 + dt.getDate()).substring(1),
    ].join('-');
    const isoDate = `${stringifiedDate}T00:00:00.000Z`;
    return `dt'${isoDate}'`;
  }
}

/**
 * Utility function to sort array of objects using Date Timestamp
 * @param {array} arratList
 * @param {string} key
 */
 export const sortByDate = (arrayList, key) => {
  if(arrayList.length === 0 || !Array.isArray(arrayList) || key === '' || key === undefined) {
    return [];
  }
  return arrayList.sort(function(x, y){
    return new Date(y[key]) - new Date(x[key]);
  })
};

// Show next ten years array in dropdown
export const getNextTenYears = () => {
  const currentYear = `FY${new Date().getFullYear()} (Current)`;
  let tenYears = [currentYear];
  for (let i = 1; i <= 10; i++) {
    const date = new Date();
    const year = date.setFullYear(date.getFullYear() + i)
    tenYears.push(`FY${new Date(year).getFullYear()}`)
  }
  return tenYears;
}

// Show next ten years array in dropdown
export const getNextTenFiscalYears = () => {
  const currDate = new Date();
  const currMonth = currDate.getMonth()
  const currYear = currMonth > 0 ? currDate.setFullYear(currDate.getFullYear() + 1)  : currDate.setFullYear(currDate.getFullYear())
  const currentYear = `FY${new Date(currYear).getFullYear()} - Current(Feb 01, ${new Date(currYear).getFullYear() - 1} - Jan 31, ${new Date(currYear).getFullYear()})`;
  let tenYears = [currentYear];
  let j = currMonth > 0 ? 2 : 1
  for (let i=j; i < j+10; i++) {
    const date = new Date();
    const year = date.setFullYear(date.getFullYear() + i)
    tenYears.push(`FY${new Date(year).getFullYear()} (Feb 01, ${new Date(year).getFullYear() - 1} - Jan 31, ${new Date(year).getFullYear()})`)
  }
  return tenYears;
}

export const getFiscalYearDates = () => {
  const today = new Date();
  const currentYear = today.getFullYear();
  const currentMonth = today.getMonth(); // January is 0

  let fiscalYearStart, fiscalYearEnd;

  if (currentMonth >= 1) { // February (1) to December (11)
    fiscalYearStart = `${currentYear}-02-01`;
    fiscalYearEnd = `${currentYear + 1}-01-31`;
  } else { // January (0)
    fiscalYearStart = `${currentYear - 1}-02-01`;
    fiscalYearEnd = `${currentYear}-01-31`;
  }

  return { start: fiscalYearStart, end: fiscalYearEnd };
}

export const getCurrentDate = () => {
  const today = new Date();
  const month = String(today.getMonth() + 1).padStart(2, '0'); // Months are 0-based
  const day = String(today.getDate()).padStart(2, '0');
  const year = today.getFullYear();
  return `${year}-${month}-${day}`;
};

export const getCurrentDateMMDDYY = () => {
  const today = new Date();
  const month = String(today.getMonth() + 1).padStart(2, '0'); // Months are 0-based
  const day = String(today.getDate()).padStart(2, '0');
  const year = String(today.getFullYear()).slice(-2); // Get the last two digits of the year
  return `${month}${day}${year}`;
};